"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisible = exports.createGetOperatorsSelector = exports.createGetDeparturesWithMinPriceWrapper = exports.createGetCategoryWithMinPriceSelector = void 0;
var _reselect = require("reselect");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _constants = require("../../../../Search/constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var domain = function domain(_) {
  return _.priceAnalytics;
};
var getVisible = exports.getVisible = (0, _reselect.createSelector)(domain, R.prop('visible'));
var sortEntitiesByOffer = R.curryN(3, function (currency, entityA, entityB) {
  var priceA = entityA.offer ? entityA.offer.price[currency] : Infinity;
  var priceB = entityB.offer ? entityB.offer.price[currency] : Infinity;
  return priceA - priceB;
});
var createGetOperatorsSelector = exports.createGetOperatorsSelector = function createGetOperatorsSelector() {
  return _reselect.createSelector.apply(void 0, [R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.CURRENCY
  }])].concat(_toConsumableArray(R.map(function (queryID) {
    return (0, _reselect.createSelector)(R.partialRight((0, _selectors2.getOperatorsWithMinPrice)(), [{
      queryID: queryID
    }]), R.partialRight((0, _selectors.getOffers)(), [{
      queryID: queryID
    }]), function (operators, offersHub) {
      return {
        operators: operators,
        offersHub: offersHub,
        queryID: queryID
      };
    });
  }, _constants.MAIN_QUERIES)), [function (currency) {
    for (var _len = arguments.length, entities = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      entities[_key - 1] = arguments[_key];
    }
    return R.call(R.pipe(R.map(function (_ref) {
      var operators = _ref.operators,
        offersHub = _ref.offersHub,
        queryID = _ref.queryID;
      return R.map(function (operator) {
        return R.mergeAll([operator, {
          offer: offersHub[operator.offerID],
          queryID: queryID
        }]);
      }, operators);
    }), R.flatten, R.groupBy(R.prop('id')), R.values, R.map(R.sort(sortEntitiesByOffer(currency))), R.map(function (operatorsGroup) {
      var _operatorsGroup = _slicedToArray(operatorsGroup, 1),
        operator = _operatorsGroup[0];
      return R.mergeAll([operator, {
        isReady: R.all(R.prop('isReady'), operatorsGroup)
      }]);
    }), R.sort(sortEntitiesByOffer(currency)), R.map(R.omit(['offer']))), entities);
  }]));
};
var DISABLED_CATEGORY = '1';
var createGetCategoryWithMinPriceSelector = exports.createGetCategoryWithMinPriceSelector = function createGetCategoryWithMinPriceSelector() {
  return _reselect.createSelector.apply(void 0, [R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.CURRENCY
  }]), R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.CATEGORY
  }])].concat(_toConsumableArray(R.map(function (queryID) {
    return (0, _reselect.createSelector)(R.partialRight((0, _selectors2.getCategoryWithMinPrice)(), [{
      paramName: _fn.QUERY_PARAMS.CATEGORY,
      queryID: queryID
    }]), R.partialRight((0, _selectors.getOffers)(), [{
      queryID: queryID
    }]), function (categories, offersHub) {
      return {
        categories: categories,
        offersHub: offersHub,
        queryID: queryID
      };
    });
  }, _constants.MAIN_QUERIES)), [function (currency, categoriesParam) {
    for (var _len2 = arguments.length, entities = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      entities[_key2 - 2] = arguments[_key2];
    }
    var categoriesWithMinPrice = R.call(R.pipe(R.map(function (_ref2) {
      var categories = _ref2.categories,
        offersHub = _ref2.offersHub,
        queryID = _ref2.queryID;
      return R.map(function (category) {
        return R.mergeAll([category, {
          offer: offersHub[category.offerID],
          queryID: queryID
        }]);
      }, categories);
    }), R.flatten, R.groupBy(R.prop('category')), R.values, R.map(R.sort(sortEntitiesByOffer(currency))), R.map(R.head), R.map(R.omit(['offer'])), R.filter(function (_ref3) {
      var category = _ref3.category;
      return category !== DISABLED_CATEGORY;
    }), R.reverse), entities);
    return categoriesWithMinPrice;
  }]));
};
var createGetDeparturesWithMinPriceWrapper = exports.createGetDeparturesWithMinPriceWrapper = function createGetDeparturesWithMinPriceWrapper(countryID) {
  return _reselect.createSelector.apply(void 0, [R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.CURRENCY
  }])].concat(_toConsumableArray(R.map(function (queryID) {
    return (0, _reselect.createSelector)(R.partialRight((0, _selectors2.createGetDeparturesWithMinPrice)(), [{
      geoID: countryID,
      queryID: queryID
    }]), R.partialRight((0, _selectors.getOffers)(), [{
      queryID: queryID
    }]), function (departures, offersHub) {
      return {
        departures: departures,
        offersHub: offersHub
      };
    });
  }, _constants.MAIN_QUERIES)), [function (currency) {
    for (var _len3 = arguments.length, entities = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      entities[_key3 - 1] = arguments[_key3];
    }
    var departuresWithMinPrice = R.call(R.pipe(R.map(function (_ref4) {
      var departures = _ref4.departures,
        offersHub = _ref4.offersHub;
      return R.map(function (departure) {
        return R.mergeAll([departure, {
          offer: offersHub[departure.offerID]
        }]);
      }, departures);
    }), R.flatten, R.groupBy(R.prop('id')), R.values, R.map(R.sort(sortEntitiesByOffer(currency))), R.map(R.head), R.sort(sortEntitiesByOffer(currency)), R.map(R.omit(['offer']))), entities);
    return departuresWithMinPrice;
  }]));
};